<div nz-form [nzLayout]="'vertical'" [formGroup]="stepForm">
  <h3>{{ "COMPONENTS.SELECT_PLAN.TITLE" | translate }}</h3>

  <div class="spacer"></div>

  <div nz-row>
    <div nz-col nzSpan="8">
      <app-search-bar
        [placeholder]="
          'COMPONENTS.SELECT_PLAN.FORM.PLAN.SEARCH_INPUT_PLACEHOLDER'
            | translate
        "
        minLength="0"
        (onSearchChanges)="onSearchPlan($event)"
      ></app-search-bar>
    </div>
  </div>

  <div class="spacer"></div>

  <nz-form-item>
    <nz-form-label nzFor="plan">
      {{ PLAN_LABEL | translate }}
    </nz-form-label>

    <nz-form-control [nzErrorTip]="planErrorTpl">
      <ng-container *ngIf="isLoading; else plansListTpl">
        <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
      </ng-container>

      <ng-template #plansListTpl>
        <div formGroupName="temp_plan">
          <nz-radio-group
            class="plans-container"
            nzName="plan"
            formControlName="planId"
          >
            <nz-card
              class="plans-container-card"
              [ngClass]="{
                'active-plan':
                  currentUserPlan && currentUserPlan?.planId === plan.planId,
                'card-badge': plan.isCustomizable
              }"
              *ngFor="let plan of filteredPlans"
            >
              <label
                [attr.data-cy]="plan.planId"
                nz-radio-button
                [nzValue]="plan.parentPlanId ? plan.parentPlanId : plan.planId"
              >
                <div class="plan-style-badge" *ngIf="plan.isCustomizable">
                  <div class="arrow-left"></div>
                  <span>
                    {{
                      "COMPONENTS.SELECT_PLAN.FORM.PLAN.PLAN_STYLE_TAG.PERSONAL"
                        | translate
                    }}
                  </span>
                </div>
                <app-plan-summary
                  [plan]="plan"
                  [isGrantPlanFormType]="isGrantPlanFormType"
                ></app-plan-summary>
              </label>
            </nz-card>
          </nz-radio-group>
        </div>
        <!-- Get plan object for Step 3 -->
        <input type="hidden" formControlName="plan" />

        <ng-container *ngIf="filteredPlans?.length === 0">
          <nz-empty></nz-empty>
        </ng-container>

        <div class="spacer"></div>

        <div nz-row nzJustify="end">
          <div nz-col="8">
            <nz-pagination
              *ngIf="lastPage"
              nzSimple
              [nzTotal]="
                pagerResponse?.totalItemCount ||
                lastPage * customPlansParam?.pager?.perPage
              "
              [nzPageIndex]="customPlansParam?.pager?.page"
              [nzPageSize]="customPlansParam?.pager?.perPage"
              (nzPageIndexChange)="onPaginationIndexChange($event)"
            ></nz-pagination>
          </div>
        </div>
      </ng-template>

      <ng-template #planErrorTpl let-control>
        <ng-container *ngIf="control.hasError('required')">
          {{ "COMPONENTS.SELECT_PLAN.FORM.PLAN.ERR.REQUIRED" | translate }}
        </ng-container>
      </ng-template>
    </nz-form-control>
  </nz-form-item>
</div>
